import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SIGN_IT_COST_IN_CENTS } from '@models/e-signing';
import { doCentsToDollars } from 'src/app/shared/core/util/money/money';

@Component({
	selector: 'app-sign-it-educational-modal',
	templateUrl: './sign-it-educational-modal.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
})
export class SignItEducationalModalComponent {
	integrationCost = doCentsToDollars(SIGN_IT_COST_IN_CENTS);
}
